import { Component, OnInit } from '@angular/core';
import { JeevesProductTableComponent } from 'gung-standard-jeeves';
import { PriceService, GungFlowService, AuthService, LocationConfigService } from 'gung-standard';
import { Router } from '@angular/router';

@Component({
    selector: 'cult-jeeves-product-table',
    templateUrl: './cult-jeeves-product-table.component.html',
    styleUrls: ['./cult-jeeves-product-table.component.scss'],
    standalone: false
})
export class CultJeevesProductTableComponent extends JeevesProductTableComponent {
  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected router: Router,
    protected locationConfigService: LocationConfigService
  ) {
    super(priceService, gungFlowService, authService, router, locationConfigService);
  }
}
